export const VEHICLES = {
  ADD_BUTTON: 'Add car',
  DELETE: 'Delete',
  MODEL: 'model?',
  TOOLTIP_CONTENT: 'Here you can add cars to your fleet.',
  MISSING_FIELDS_MESSAGE:
    'Fill in the missing information on the cars marked with an icon',
  CHECKBOX_LABEL: 'Show only cars required to fill in',
}

export const VEHICLES_DELETE_CONFIRMATION = {
  CONFIRMATION_MODAL: {
    QUESTION: 'Are you sure that you want to delete',
  },
  SUCCESS: 'The car has been successfully deleted',
}
